import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

export default function SpedPage() {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/fiscal/sped/documents`);
    }
  }, [match]);

  return null;
}
